import React, { useEffect } from "react";
import { store } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import "../../../../node_modules/animate.css";
import NotificationContainer from "../NotificationContainer";

export default function RealTimeNotifications(props) {
  const { data, onRemoval } = props;

  const CustomComponent = () => {
    return (
      <div className="customNotification">
        <div className="notification__close"></div>
        <NotificationContainer data={data} showTime={false} />
      </div>
    );
  };

  useEffect(() => {
    const generateNotification = () => {
      store.addNotification({
        content: CustomComponent,
        insert: "top",
        container: "bottom-right",
        animationIn: ["animate__animated", "animate__slideInRight"],
        animationOut: ["animate__animated", "animate__slideOutRight"],
        dismiss: {
          duration: 5000,
          showIcon: true,
        },
        width: 300,
        onRemoval,
      });
    };
    generateNotification();
  }, []);

  return <span></span>;
}
